import { atom } from 'jotai'
import { z } from 'zod'
import { isBefore, getYear } from 'date-fns'

export const BasicJobApplicationInfoSchema = z.object({
  targetEmploymentYear: z.number(),
})

export type BasicJobApplicationInfoForm = z.input<typeof BasicJobApplicationInfoSchema>

function getDefaultTargetEmploymentYear(): number {
  const now = new Date()
  const thisYear = getYear(now)
  const juneFirst = new Date(thisYear, 5, 1)
  return thisYear + (isBefore(now, juneFirst) ? 1 : 2)
}

export const basicJobApplicationInfoValues: BasicJobApplicationInfoForm = {
  targetEmploymentYear: getDefaultTargetEmploymentYear(),
}

export const basicJobApplicationInfoAtom = atom<BasicJobApplicationInfoForm>(
  basicJobApplicationInfoValues
)
